<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col span="24">
            <h4>门店评分</h4>
          </el-col>
          <el-col span="7">
            <el-form-item label="服务" prop="">
              <el-input :disabled="true" placeholder="5分"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="7">
            <el-form-item label="环境" prop="">
              <el-input :disabled="true" placeholder="5分"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="7">
            <el-form-item label="品种" prop="">
              <el-input :disabled="true" placeholder="5分"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="门店评价" prop="cardNo"> </el-form-item>
          </el-col>
          <el-col span="24">
            <el-table :data="tableData" height="260" border style="width: 100%">
              <el-table-column 
              prop="userName" 
              label="用户" 
              width="200" 
              align="center">
              </el-table-column>
              <el-table-column
                prop="content"
                label="评价内容"
                align="center"
              ></el-table-column>
              <!-- <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="editComment()">编辑</el-button>
                  <el-button type="text" size="small" @click="deleteComment()">删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- <div style="text-align: center" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model === 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div> -->
  </div>
</template>
  <script>
import {
  getList,
} from '@/api/v4ward/offline/merchant/comment/offlinemerchantcomment';
export default {
  props: {
    row: {
      default: {},
    },
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      tableData: [],
      form: {
        userName: '',
        content: '',
      },
      formRules: {
        userName: [{ required: true, message: '用户不能为空', trigger: 'change' }],
        content: [{ required: true, message: '评价内容不能为空', trigger: 'change' }],
      },
    };
  },
  created() {
    console.log(this.model);
    console.log(this.row);
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    //获取列表接口
    getCommentTable(){
      getList({merchantId:this.row.id}).then(res=>{
        this.tableData = res.data
      })
    },
    async initData() {
      this.getCommentTable()
    },
    saveRecord() {
      if (this.model === 'add') {
      
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  